import { checkIsUrlInvalid } from "@/services/tools/urlValidation/checkIsUrlInvalid";
import { CheckoutErrorNames, CheckoutErrors } from "@/store/checkoutCreator/types";
import { LandingCheckoutPayload } from "@dev/ee-api/ee-api-models";
import { isProductPriceValid } from "./isProductPriceValid";

const isErrorIncluded = (conditionErrorName: CheckoutErrorNames, errorNames?: CheckoutErrorNames[]): boolean => 
    !errorNames?.length || !!errorNames?.includes(conditionErrorName);

export const getCheckoutErrors = (checkoutPayload: LandingCheckoutPayload, errorNames?: CheckoutErrorNames[]): CheckoutErrors => {
    const errors: CheckoutErrors = {}
    if (isErrorIncluded(CheckoutErrorNames.INVALID_PRODUCT_URL, errorNames) && checkIsUrlInvalid(checkoutPayload?.DownloadUrl, true)) {
        errors[CheckoutErrorNames.INVALID_PRODUCT_URL] = true;
    }
    if (isErrorIncluded(CheckoutErrorNames.INVALID_PRODUCT_PRICE, errorNames) && checkoutPayload?.ProductPrice >=0 && !isProductPriceValid(checkoutPayload?.ProductPrice, checkoutPayload?.Currency)) {
        errors[CheckoutErrorNames.INVALID_PRODUCT_PRICE] = true;
    }
    if (errorNames && isErrorIncluded(CheckoutErrorNames.EMPTY_CHECKOUT_AUDIENCE, errorNames) && !checkoutPayload?.CheckoutAudience?.length) {
        errors[CheckoutErrorNames.EMPTY_CHECKOUT_AUDIENCE] = true;
    }
    return errors;
}
